import { getRe2RegexError } from "@/utils/regex";

/**
 * type, patternのセットを受け取ってバリデーションする
 * typeがREGEXまたはNOT_REGEXのとき、Re2の構文に合致しているかテストする
 * @param type
 * @param pattern
 * @returns
 */
export function validateRe2RegexPattern(
  type: string,
  pattern: string,
): string | undefined {
  if (type === "REGEX" || type === "NOT_REGEX") {
    return getRe2RegexError(pattern) ?? undefined;
  }
  return undefined;
}
